<button
    type="button"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    aria-haspopup="menu"
    [attr.aria-label]="'Open user menu for ' + (fullName || 'user')"
    class="avatar-button"
>
  <span
      class="avatar"
      [style.background-color]="backgroundColor"
      [style.color]="textColor"
      aria-hidden="true"
  >
    {{ computedInitials }}
  </span>
</button>

<mat-menu #menu="matMenu" xPosition="before" yPosition="below" class="avatar-menu-panel">
    <div class="menu-header" mat-menu-item disabled [ngStyle]="{textAlign: 'center'}">
        <div class="menu-header__text">
            <div class="name" [title]="fullName">{{ fullName || 'User' }}</div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="menu-toggle" mat-menu-item>
        <mat-slide-toggle
            [checked]="isDarkMode"
            aria-label="Toggle Show Tags"
            matTooltip="{{showTagsTooltip}}"
            [formControl]="showTagsToggle"
        >
            Show Tags
        </mat-slide-toggle>
    </div>
    <mat-divider></mat-divider>
    <div class="menu-toggle" mat-menu-item>
        <mat-slide-toggle
            [checked]="isDarkMode"
            aria-label="Toggle dark mode"
            matTooltip="{{darkModeTooltip}}"
            [formControl]="darkModeToggle"
        >
            Dark mode
        </mat-slide-toggle>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onSignOut()" [ngStyle]="{textAlign: 'center'}" matTooltip="Sign Out of EMM">
        <mat-icon>switch_account</mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
